import { fulfillmentApi } from "../../../api/fulfillmentApi";
import { AppDispatch, RootState } from "../../store";
import { setSize, setSizes, startLoadingSizes } from "./sizesSlice";

export const getSizes = () => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingSizes());
        const resp = await fulfillmentApi.get(`sizes`);

        dispatch(setSizes({ sizes: resp.data }));
    }
}

export const getSize = (sizeId: string) => {
    return async (dispatch: AppDispatch, getState: () => RootState) => {
        dispatch(startLoadingSizes());
        const resp = await fulfillmentApi.get(`sizes/${sizeId}`);

        dispatch(setSize({ size: resp.data }));
    }
}